import React from 'react'
import Icon from 'react-fa'
import {t} from '../helpers/translate'
import {redirectIfNotLoggedIn, getAccessLevel, checkSchool} from '../helpers/access'
const config = require('config');

class LandingPage extends React.Component {

  constructor(props) {

    if(!("config" in sessionStorage)) {
      window.location.reload();
    }

    redirectIfNotLoggedIn();
    super(props);
    this.state = {}
  }

  getTileIcon(tile) {
  	return tile.icon;
  }

  getTileLink(tile){
    if(tile.custom_link){
      return tile.custom_link.replace('agentcode', sessionStorage.getItem('csr_token'));
    }

    return tile.link;
  }

  getTileTarget(tile){
    return tile.custom_link ? "_blank" : '';
  }

  renderTile(tile) {
  	return <div className="landing-page-tile-layout row">
  		<a href={this.getTileLink(tile)} className="col-xs-6 col-sm-4">
	  		<div className="col-sm-12 landing-page-tile">
	  			<div className="col-sm-2 landing-tile-icon">
	  				<Icon name={tile.icon} size="2x"/>
		  		</div>
	  			<div className="col-sm-10 landing-tile-text">
					  {t(tile.label)}
			  	</div>
	  		</div>
  		</a>
		</div>
  }

  getPageTitle(title) {
    return title || config.default.landing[sessionStorage.getItem('org')].titles[getAccessLevel()];
  }

  render() {
  	const orgConfig = config.default.landing[sessionStorage.getItem('org')]
  	const tiles = config.default.landing.tiles
  	const authlevel = getAccessLevel()

     return <div className='container'>
        <div className="text-center bg-inherit">
          <h2 className="page-title">{`${t('Welcome to the')} ${this.getPageTitle(orgConfig.title)} ${t('Insurance Dashboard')}`}</h2>
		  		<div className="landing-page-layout">
	      		{orgConfig.tiles[authlevel].map(
	          	(tile) => <p>{this.renderTile(tiles[tile])}</p>
	      		)}
					</div>
        </div>
     </div>
  }
}
LandingPage.displayName = 'Homepage';
export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/Landing.js